module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingClans/components/Card/components/Stat/images/victories.f2e0176f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Card/components/Stat/images/victories.png
// module id = 3127
// module chunks = 11